import { componentTypes } from '../../constants/componentTypes';
import { FormField } from './FormField';

export class RadioFormField extends FormField {
  component = componentTypes.RADIO;
}
